import { render, staticRenderFns } from "./ems_postFilesWithCover.vue?vue&type=template&id=3ab4256c&scoped=true"
import script from "./ems_postFilesWithCover.vue?vue&type=script&lang=js"
export * from "./ems_postFilesWithCover.vue?vue&type=script&lang=js"
import style0 from "./ems_postFilesWithCover.vue?vue&type=style&index=0&id=3ab4256c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4256c",
  null
  
)

export default component.exports